export const keys: (keyof CreateCampaignObjectiveBasedFormData)[] = ['products']

export const validator = (selectedProducts: Product[]) => {
  if (!selectedProducts?.length) {
    return false
  }
  return true
}
